import { render, staticRenderFns } from "./TakipAcIslemDetayView.vue?vue&type=template&id=59ecf2de&scoped=true"
import script from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecf2de",
  null
  
)

export default component.exports